module.exports = __webpack_public_path__ + "images/arrow-down2140732154b91010ce61936717444ee8.svg";